export const SITEREFLEX_ENDPOINT = "https://demosdk.weibotop.cn" as const;
export const DEFAULT_SITEREFLEX_SITE_AGENT_ID = "weibotop-production";

export type AssistantMode = "legacy" | "sitereflex" | "off";

export interface AssistantIntegrationInput {
  mode?: string;
  siteAgentId?: string;
  readOnlyCapabilityIds?: string;
}

export interface AssistantIntegration {
  mode: AssistantMode;
  endpoint: typeof SITEREFLEX_ENDPOINT;
  siteAgentId: string;
  readOnlyCapabilityIds: string[];
}

const PUBLIC_ROUTE_PREFIXES = [
  "/history",
  "/search",
  "/daily",
  "/topic",
  "/topics",
  "/celebrity",
  "/city",
  "/country",
  "/compare",
  "/douyin",
  "/wordcloud",
  "/guides",
  "/about",
  "/methodology",
] as const;

function parseAssistantMode(value: string | undefined): AssistantMode {
  const normalized = value?.trim().toLowerCase();
  if (normalized === "sitereflex" || normalized === "off") return normalized;
  return "legacy";
}

function parseSiteAgentId(value: string | undefined): string {
  const normalized = value?.trim();
  if (normalized && /^[a-z0-9][a-z0-9_-]{0,63}$/i.test(normalized)) {
    return normalized;
  }
  return DEFAULT_SITEREFLEX_SITE_AGENT_ID;
}

export function resolveAssistantIntegration(
  input: AssistantIntegrationInput,
): AssistantIntegration {
  return {
    mode: parseAssistantMode(input.mode),
    endpoint: SITEREFLEX_ENDPOINT,
    siteAgentId: parseSiteAgentId(input.siteAgentId),
    readOnlyCapabilityIds: Array.from(new Set((input.readOnlyCapabilityIds || "")
      .split(",")
      .map((value) => value.trim())
      .filter((value) => /^[a-z0-9][a-z0-9:_-]{0,127}$/i.test(value)))),
  };
}

export function getAssistantIntegration(): AssistantIntegration {
  return resolveAssistantIntegration({
    mode: process.env.NEXT_PUBLIC_SITE_ASSISTANT_MODE,
    siteAgentId: process.env.NEXT_PUBLIC_SITEREFLEX_SITE_AGENT_ID,
    readOnlyCapabilityIds: process.env.NEXT_PUBLIC_SITEREFLEX_READ_ONLY_CAPABILITY_IDS,
  });
}

export function isSiteReflexPublicPath(pathname: string): boolean {
  const path = pathname.split(/[?#]/, 1)[0];
  if (path === "/") return true;
  return PUBLIC_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
